import React, { useState } from 'react';
import { PrimaryButtonGreen, SecondaryButtonOutline } from '../ui/Buttons';
import { Loader2 } from 'lucide-react';
export function FiltersPanel() {
  const [brightness, setBrightness] = useState(50);
  const [contrast, setContrast] = useState(50);
  const [saturation, setSaturation] = useState(50);
  const [removeBg, setRemoveBg] = useState(false);
  return <div className="h-full flex flex-col" data-id="element-196">
      <div className="p-4 border-b border-gray-100" data-id="element-197">
        <h2 className="font-semibold text-gray-900" data-id="element-198">Filters</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-199">
        {/* Sliders */}
        <div className="space-y-4" data-id="element-200">
          <div data-id="element-201">
            <div className="flex justify-between mb-1" data-id="element-202">
              <label className="text-sm font-medium text-gray-700" data-id="element-203">
                Brightness
              </label>
              <span className="text-sm text-gray-500" data-id="element-204">{brightness}</span>
            </div>
            <input type="range" min="0" max="100" value={brightness} onChange={e => setBrightness(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-205" />
          </div>

          <div data-id="element-206">
            <div className="flex justify-between mb-1" data-id="element-207">
              <label className="text-sm font-medium text-gray-700" data-id="element-208">
                Contrast
              </label>
              <span className="text-sm text-gray-500" data-id="element-209">{contrast}</span>
            </div>
            <input type="range" min="0" max="100" value={contrast} onChange={e => setContrast(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-210" />
          </div>

          <div data-id="element-211">
            <div className="flex justify-between mb-1" data-id="element-212">
              <label className="text-sm font-medium text-gray-700" data-id="element-213">
                Saturation
              </label>
              <span className="text-sm text-gray-500" data-id="element-214">{saturation}</span>
            </div>
            <input type="range" min="0" max="100" value={saturation} onChange={e => setSaturation(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600" data-id="element-215" />
          </div>
        </div>

        {/* Background Removal */}
        <div className="pt-4 border-t border-gray-100" data-id="element-216">
          <div className="flex items-center justify-between mb-2" data-id="element-217">
            <span className="text-sm font-medium text-gray-700" data-id="element-218">
              Remove background
            </span>
            <button onClick={() => setRemoveBg(!removeBg)} className={`w-11 h-6 rounded-full transition-colors relative ${removeBg ? 'bg-violet-600' : 'bg-gray-200'}`} data-id="element-219">
              <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${removeBg ? 'left-6' : 'left-1'}`} data-id="element-220" />
            </button>
          </div>

          {removeBg && <div className="flex items-center gap-2 text-sm text-violet-600 bg-violet-50 p-2 rounded-lg" data-id="element-221">
              <Loader2 size={14} className="animate-spin" data-id="element-222" />
              Processing background removal...
            </div>}
        </div>

        <div className="bg-blue-50 text-blue-700 p-3 rounded-lg text-xs" data-id="element-223">
          Tip: use background removal for raster images.
        </div>
      </div>

      <div className="p-4 border-t border-gray-100 flex gap-3" data-id="element-224">
        <PrimaryButtonGreen className="flex-1" data-id="element-225">Apply</PrimaryButtonGreen>
        <SecondaryButtonOutline className="flex-1" data-id="element-226">
          Reset
        </SecondaryButtonOutline>
      </div>
    </div>;
}